
export const constObj = {
  generalFeedbackSuccess: "Feedback Submitted",
  generalFeedbacemailFail: "Unable to Submit Feedback",
  annotationAddedSuccessMessage: "Annotation Added",
  annotationEditedSuccessMessage: "Annotation Edited",
  annotationAddedFailMessage: "Unable to Add Annotation",
  annotationEditedFailMessage: "Unable to Edit Annotation",
  annotationDeletionConfirmationPromptMessage: "Are you sure you want to delete this annotation?",
  annotationAlertPrintQueue: "If you leave this page, your print queue will be cleared.<br> Do you want to continue?",
  annotationRemovedSuccessMessage: "Annotation Removed",
  annotationRemovedFailMessage: "Unable to Remove Annotation",
  linkSharedMessage: "Link Copied to Clipboard",
  bookmarkAddedMessage: "Bookmark Added",
  bookmarkAddedFailMessage: "Unable to Add Bookmark",
  bookmarkRemovedMessage: "Bookmark Removed",
  deleteAllPrintQueue: "Are you sure you want to delete queue for all selected paragraphs?",
  Norecords: "No Records Found",
  contactSupportSuccess: "Your feedback was successfully sent.",
  invalidDateMessagePCS: "Please Enter Fiscal Year Beginning Date in valid format (MM/DD/YYYY).",
  invalidDateDurationMessagePCS: "You must enter a valid date (format 'MM/DD/YYYY'). Date can be prior to, or 3 years from, today's date.",
  AdminErrorMessage: "The following users are currently Logged In:",
  microserviceFailureOnAccessManagement: "Unable to load users. Please try again after some time.",
  userDeletionConfirmationPromptMessage: "Are you sure you want to delete this user?",
  userRemovedSuccessMessage: "User removed",
  userRemovedFailMessage: "Unable to remove user",
  userEditedSuccessMessage: "User modified",
  userAddedSuccessMessage: "User added",
  userAddedFailMessage: "Unable to add user",
  userEditedFailMessage: "Unable to modify user",
  passwordReset: "Your password has been reset. Please log in again.",
  adminDetailsUpdate: "Your account details have been updated. Please log in again.",
  aaaFeaturemessage: "For more information regarding your AAA account, please go to <br/> <a class='mr-12-5rem' target='_blank' href='https://aaahq.org/Research/FASB-GARS'>https://aaahq.org/Research/FASB-GARS</a>",
  archiveVersionNavigationAlert: "You will be navigating to Archive Version: ",
  continueMessage: "Do you want to continue?",
  currentVersionNavigationAlert: "This will exit you from the Archive.",
  currentVersionNavigationGASBIconAlert: "This will exit you from the Archive.<br/>Do you want to continue?",
  redisCacheClearMessage: "Redis cache cleared for ",
  redisCacheClearFailedMessage: "Unable to clear Redis cache. Please try again.",
  redisCacheClearConfirmationMessage: "Are you sure you want to clear the cache for the <b>{SITENAME}</b> application?"
};


